/** Provide tab entries into the shared grids' scrollable headers and rows without changing their ARIA hierarchy. */
export function enableGridHeaderKeyboardScroll(host: HTMLElement): void {
  host
    .querySelectorAll<HTMLElement>(
      '.ag-header-viewport, .ag-center-cols-viewport',
    )
    .forEach((viewport) => {
      const firstCell = viewport.querySelector<HTMLElement>(
        '[role="columnheader"], [role="gridcell"]',
      );
      if (firstCell) firstCell.tabIndex = 0;
    });
}
